import React, { useEffect, useState } from "react";
import API from "../utils/axiosInstance"
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

const Attendance = () => {
  const [users, setUsers] = useState([]);
  const [courses, setCourses] = useState([]);
  const [courseId, setCourseId] = useState("");
  const [sessionDate, setSessionDate] = useState("");
  const [attendance, setAttendance] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const courseRes = await API.get("/courses/allCourses");
        setCourses(courseRes.data);
      } catch (err) {
        console.error("Failed to fetch courses:", err);
      }
    };
    fetchCourses();
  }, []);
  
  useEffect(() => {
    const fetchUsersForCourse = async () => {
      if (!courseId) return;
  
      try {
        const userRes = await API.get("/users/by-course", {
          params: { courseId },
        });
  
        setUsers(userRes.data);
        setAttendance(userRes.data.map((u) => ({
          userId: u.id,
          isPresent: true,
        })));
      } catch (err) {
        console.error("Failed to fetch users for course:", err);
      }
    };
  
    fetchUsersForCourse();
  }, [courseId]);
  
  
  
  const handleAttendanceChange = (userId, isPresent) => {
    setAttendance((prev) =>
      prev.map((entry) =>
        entry.userId === userId ? { ...entry, isPresent } : entry
      )
    );
  };

  
const handleSubmit = async (e) => {
    e.preventDefault();
    if (!courseId || !sessionDate) return alert("Course and date required");
  
    try {
      await Promise.all(
        attendance.map((entry) =>
          API.post("/attendance/mark", {
            userId: entry.userId,
            courseId,
            sessionDate,
            isPresent: entry.isPresent,
          })
        )
      );
  
      alert("Attendance submitted!");
      setCourseId("");
      setSessionDate("");
    } catch (err) {
      console.error("Bulk marking failed", err);
      alert("Error while submitting.");
    }
  };

  return (
    <div className="d-flex">
      <Sidebar isOpen={isSidebarOpen} />
      <div className="main-container w-full">
        <Navbar onToggleSidebar={() => setIsSidebarOpen(prev => !prev)} />
        <div className="p-6 max-w-6xl mx-auto">
          <h2 className="text-2xl font-bold mb-6 text-center">Bulk Attendance</h2>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="flex gap-4">
              <select
                value={courseId}
                onChange={(e) => setCourseId(e.target.value)}
                className="w-1/2 border p-2 rounded"
                required
              >
                <option value="">Select Course</option>
                {courses.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.title}
                  </option>
                ))}
              </select>

              <input
                type="date"
                value={sessionDate}
                onChange={(e) => setSessionDate(e.target.value)}
                className="w-1/2 border p-2 rounded"
                required
              />
            </div>

            <div className="overflow-x-auto border rounded">
              <table className="w-full text-sm">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-2 border">User</th>
                    <th className="p-2 border">Present</th>
                    <th className="p-2 border">Absent</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => {
                    const entry = attendance.find((a) => a.userId === u.id) || {};
                    return (
                      <tr key={u.id}>
                        <td className="p-2 border">{u.name}</td>
                        <td className="p-2 border text-center">
                          <input
                            type="radio"
                            checked={entry.isPresent === true}
                            onChange={() => handleAttendanceChange(u.id, true)}
                          />
                        </td>
                        <td className="p-2 border text-center">
                          <input
                            type="radio"
                            checked={entry.isPresent === false}
                            onChange={() => handleAttendanceChange(u.id, false)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
            >
              Submit Attendance
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Attendance;
